// function w3_open() {
//     document.getElementById('contents_wrapper').style.marginLeft = '25%';
//     document.getElementById('mySidebar').style.width = '25%';
//     document.getElementById('mySidebar').style.display = 'block';
//     document.getElementById('openNav').style.display = 'none';
//   }
//   function w3_close() {
//     document.getElementById('contents_wrapper').style.marginLeft = '0%';
//     document.getElementById('mySidebar').style.display = 'none';
//     document.getElementById('openNav').style.display = 'inline-block';
//   }
  

  
  (function($, B) {
    'use strict';
    function correctPosition(){
        var $togglers = $('.sidebar-toggler');
        $togglers.each(function(){
            var 
                parent = this.parentElement,
                top = B.str.toInt(this.style.top),
                maxTop = parseInt(parent.offsetTop + parent.clientHeight - window.scrollY - this.offsetHeight);
            if(this.offsetTop > maxTop || (top > 0 &&  maxTop < parent.offsetTop) ){
                this.style.top = maxTop+'px';
            }else{               
                this.style.top =  '';
            }
        });
    }

    $.fn.initSidebar=function(){
        var $sidebar = $(this),
            o = $.extend(true, { 
                opening: -1,
                min: 0,
                max: 200
            }, $sidebar.data()),
            min = o.min + 'px',
            max = o.max + 'px',
            direction = $sidebar.hasClass('sidebar-left') ? 1 : -1,
            $toggler = $('[data-sidebar-toggler=' + $sidebar.attr('id') + ']'),
            openSidebar = function(){
                $sidebar[0].style.width = max;
                $sidebar.addClass('opened');
                $toggler[0].style[direction > 0 ? 'left' : 'right'] = max;
                $toggler.addClass('opened');
            },
            closeSidebar = function(){
                $sidebar.removeClass('opened');
                $sidebar[0].style.width = min;
                $toggler.removeClass('opened');
                $toggler[0].style[direction > 0 ? 'left' : 'right'] = min;
            };

            $toggler.on('click', function(){
                if($sidebar.hasClass('opened')){
                    closeSidebar();
                }else{
                    openSidebar();
                }
            });
            if((o.opening > 0) && (window.innerWidth > o.opening)){
                if(!$sidebar.hasClass('opened')){
                    openSidebar();
                }
            }else if($sidebar.hasClass('opened')){
                closeSidebar();
            }            
    };

    B.web.onReady['sidebarToggler'] = function(){
        $('.sidebar').each(function(){
            $(this).initSidebar();
        });
    };
    B.web.onScroll['sidebarToggler'] = correctPosition;
    B.web.onResize['sidebarToggler'] = correctPosition;

    
})(jQuery, Bajt);
